export const HREF_TARGET = "_self";
export const PADDING = 6;
export const baseColor = "#e90139";
export const hoverColor = "#C70139";
export const fontFamily = "Helvetica, sans-serif, Arial";